import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { renderFont } from '@empiriecom/module-components/ThemeProvider';
import { PickerTile } from './tile';
import { SubDimensionWrapper, SubDimensionName } from './styles';
import { PickerTilesLayoutProps } from './types';

const PickerTilesWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

const TilesHeadline = styled.div`
  ${({ theme }) => renderFont('base', 'bold', theme)};
  font-size: 1rem;
  margin: 0.5rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
`;

const PickerTilesContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: row wrap;
`;

export const DesktopPickerTiles: FunctionComponent<PickerTilesLayoutProps> = ({
  dimension,
  setProduct,
}): ReactElement => (
  <PickerTilesWrapper data-testid="desktop-picker">
    <TilesHeadline>
      {dimension.displayName && dimension.displayName !== '' ? (
        dimension.displayName
      ) : (
        <FormattedMessage id="dimension-name.variant" defaultMessage="Variante" />
      )}
    </TilesHeadline>
    <PickerTilesContainer>
      {dimension.values.map((value, indx) =>
        value.subDimension ? (
          <SubDimensionWrapper
            data-testid="desktop-subdimension-wrapper"
            key={value.displayText?.concat(indx.toFixed())}
          >
            <SubDimensionName data-testid="desktop-subdimension-name" isMobile={false}>
              {value.displayText}
            </SubDimensionName>
            <PickerTilesContainer>
              {Object.keys(value.subDimension.values).map((subDimVal, idx) => (
                <PickerTile
                  value={value.subDimension.values[subDimVal]}
                  setProduct={setProduct}
                  axisType={dimension.axisType}
                  availability={value.subDimension.values[subDimVal].availability}
                  inputType={dimension.type}
                  key={value.subDimension.values[subDimVal].displayText?.concat(idx.toFixed())}
                />
              ))}
            </PickerTilesContainer>
          </SubDimensionWrapper>
        ) : (
          <PickerTile
            value={value}
            setProduct={setProduct}
            axisType={dimension.axisType}
            key={value.displayText?.concat(indx.toFixed())}
            availability={value.availability}
            inputType={dimension.type}
          />
        ),
      )}
    </PickerTilesContainer>
  </PickerTilesWrapper>
);

export default DesktopPickerTiles;
